import React from "react";
import ReactDOM from "react-dom/client";
import SiteMap from "../components/dynamicMap/SiteMap";

export default () => {
  const element = document.getElementById("site-dynamic-map-root");
  if (!element) return;

  if (
    !element.dataset.gcp ||
    !element.dataset.resources ||
    !element.dataset.sites ||
    !element.dataset.basePath ||
    !element.dataset.mapCenter ||
    !element.dataset.site
  )
    return;

  ReactDOM.createRoot(element).render(
    <SiteMap
      gcp={JSON.parse(element.dataset.gcp)}
      resources={JSON.parse(element.dataset.resources)}
      sites={JSON.parse(element.dataset.sites)}
      basePath={element.dataset.basePath}
      mapCenter={JSON.parse(element.dataset.mapCenter)}
      site={JSON.parse(element.dataset.site)}
    />,
  );
};
